import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationResetVariationArgs, BackendVariation } from 'src/types/backend';

const MUTATION = gql`
  mutation ResetVariation($id: ID!) {
    resetVariation(id: $id) {
      id
      copyText: acCopyText
      copyTextMarkup
      score
      engagementScoreSupportSize
      isScoreLocked
      performancePredictionsScoreLocked
      ageScoreHistogram
      genderScoreHistogram
    }
  }
`;

type Variables = BackendMutationResetVariationArgs;
type Result = BackendVariation;

export const resetVariation = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
